import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import Info, { Item, Metric } from '../../Info';
import { selectBidMetrics } from '../../../store/selectors/metrics';
import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    minWidth: '250px',
  },
  section: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    textAlign: 'center',
  }
});


const BidsCardsSide = ({ metrics }) => {
  return(
    <Tooltip type={TooltipTypes.bid.BID_INFO_PANEL} placement="left-end">
      <div>
        <Info title="Bid KPIs">
          {metrics.map((metric, i) => {
            return (
              <Item key={i}>
                <Metric
                  type={metric.type}
                  label={metric.label}
                  value={metric.display} />
              </Item>
            );
          })}
        </Info>
      </div>
    </Tooltip>
  );
};

const mapStateToProps = (state) => ({
  metrics: selectBidMetrics(state),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(BidsCardsSide);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsCardsSide.jsx